module.exports = __webpack_public_path__ + "static/images/sync-event.728181690dbb9f608d9bee2ca31bcb16.svg";